if(!customElements.get("m-collection-header")){class e extends HTMLElement{constructor(){super()}connectedCallback(){const{MinimogThemeScripts:e}=window;if("true"===this.dataset.enableParallax&&window.innerWidth>767){const a=this.querySelector(".m-collection-page-header__bg");loadAssetsNew([e.parallax],"parallax-module-collection-header",(()=>{new MinimogLibs.simpleParallax(a,{delay:1.8,transition:"cubic-bezier(0,0,0,1)",orientation:"down",scale:1.5,customWrapper:".m-collection-page-header"})}))}}}customElements.define("m-collection-header",e)}


// read more
$(document).ready(function() {

      if ($('.read_btn').length === 0) {
        // If it doesn't exist, apply display: none to the target class
        $('.m-collection-page-header__description_x').css('display', 'none');
    }
  
    $('.read_more_btn').click(function() {
        var button = $(this);
        $('.more_content').slideToggle(function() {
            // Change button text based on visibility after the toggle completes
            if ($('.more_content').is(':visible')) {
                button.hide(); // Hide the Read More button
                $('.show_less_btn').show(); // Show the Show Less button
            } else {
                button.show(); // Show the Read More button
                $('.show_less_btn').hide(); // Hide the Show Less button
            }
        });
    });

    // Optional: Click event for Show Less button
    $('.show_less_btn').click(function() {
        $('.more_content').slideUp(function() {
            $('.read_more_btn').show(); // Show the Read More button
            $(this).find('.show_less_btn').hide(); // Hide the Show Less button
        });
    });
});


